import type { Manifest } from './base/Field'
import HyModel from './base/Model'

export default class Preferences extends HyModel {
  override options() {
    return {
      remoteModel: 'Preference',
    }
  }

  override manifest(): Manifest {
    return {
      default_home_page: {
        type: 'select',
        options: {
          items: useUiStore().navigationItemsList
        }
      },
      // System
      selection: {}
    }
  }
}
